// src/sections/MenuFormulas/MenuFormulas.js
import React from 'react';
import styles from './MenuFormulas.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';

const menuFormulaData = {
  id: "menu-poke-bowl-formula", // ID UNIQUE
  name: "MENU POKE BOWL",
  price: "17,00 €",
  description: "1 Poke* + 1 Dessert + 1 Boisson",
  note: "*Poke au choix parmi : Poulet, Veggie. (Saumon, Thon, Mix = +1€)"
};

// Le composant reçoit les props favorites, addFavorite, removeFavorite de App.js
const MenuFormulas = ({ id, favorites, addFavorite, removeFavorite }) => {

  const isFavorite = (item) => {
    // Pour la formule, nous vérifions directement l'ID de la formule
    return favorites.some(favItem => favItem.id === item.id);
  };

  const handleFavoriteClick = (item) => {
    if (isFavorite(item)) {
      removeFavorite(item.id);
    } else {
      addFavorite(item);
    }
  };

  return (
    <section id={id} className={styles.menuFormulas}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>MENU & FORMULES</h2>
        
        <div className={styles.formulaCard}>
          <div className={styles.formulaHeader}>
            <span className={styles.formulaName}>{menuFormulaData.name}</span>
            <span className={styles.formulaPrice}>{menuFormulaData.price}</span>
          </div>
          <p className={styles.formulaDescription}>{menuFormulaData.description}</p>
          <p className={styles.formulaNote}>{menuFormulaData.note}</p>

          {/* Bouton favoris pour la formule */}
          <button
            className={`${styles.favoriteButton} ${isFavorite(menuFormulaData) ? styles.isFavorite : ''}`}
            onClick={() => handleFavoriteClick(menuFormulaData)}
            aria-label={isFavorite(menuFormulaData) ? `Retirer ${menuFormulaData.name} des favoris` : `Ajouter ${menuFormulaData.name} aux favoris`}
          >
            <FontAwesomeIcon icon={isFavorite(menuFormulaData) ? solidHeart : regularHeart} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default MenuFormulas;